
<template>
  <span>
    <span v-if="prize.type == 'COINS'"><coins-widget :amount="prize.data.coins"/></span>
    <span v-else-if="prize.type == 'CUSTOM'">{{prize.data.text}}</span>
    <span v-else-if="prize.type == 'PERCENT_FROM_POT'"><percent-pott-widget :percent="prize.data.percent"/></span>
    <span v-else>???</span>
  </span>
</template>

<script>
import CoinsWidget from '../CoinsWidget.vue';
import PercentPottWidget from './PercentPottWidget.vue';

export default {
  components: { CoinsWidget, PercentPottWidget },
  name: "PrizeWidget",
  mixins: [],
  props: {
    prize: {
      type: Object,
      required: true
    }
  }
};
</script>